import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarService } from 'src/app/pages/calendar/services/calendar.service';
import { UiServices } from 'src/app/services/ui-services';
import { ShowTermsComponent } from '../show-terms/show-terms.component';
import { AcceptScheduleComponent } from 'src/app/pages/calendar/components/accept-schedule/accept-schedule.component';
import { LangService } from 'src/app/services/lang.service';
import { timeToMilliseconds } from 'src/utils/parseHourToMs';
import { verifyZDate } from 'src/utils/VerifyZDate';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { GmtMessageComponent } from 'src/app/pages/calendar/components/gmt-message/gmt-message.component';

declare var FullCalendar;

@Component({
  selector: 'app-calendar-date',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  @Input() isOperatorView = false;
  @Output() openAgendedList = new EventEmitter();

  @Input() operator: any = undefined;
  @Input() blockDays = true;
  @Input() blockedTurns: any[] = undefined;
  @Output() emitMeet = new EventEmitter();
  @Input() set date(meetingData: any) {
    if (meetingData) {
      this.meetingData = meetingData.data.item;
      const value = meetingData.data;
      this._businessHours = [];
      this.loading = true;
      const availableDays = [0, 1, 2, 3, 4, 5, 6];
      let unWorkDays = [];
      let workDays = [];
      this._duration = value.duration || 1;
      this._heightContent = (this._duration / 60) * 24 * 2;
      const scheduleOperator: any[] = value.item;
      this.calendar && this.calendar.destroy();
      scheduleOperator.map((item) => {
        const days: any[] = item.day.split(',');
        item.startTime = item.init;
        item.endTime = item.end;
        const { initToMs, endTimeToMs } = this.calendarSv.timeToMs(item);
        this.blockTurns(item);
        days.map((day) => {
          day = Number(day);
          const existBusinessDay = this.daysOfWeek.findIndex(
            (schedule) => schedule.day === day
          );
          if (existBusinessDay !== -1) {
            this.daysOfWeek[existBusinessDay].hours +=
              (endTimeToMs - initToMs) / 3600000;
          } else {
            const businessDays = {
              day,
              hours: (endTimeToMs - initToMs) / 3600000,
            };
            this.daysOfWeek.push(businessDays);
          }
          const existDay = !!workDays.find((workDay) => workDay === day);
          if (!existDay) {
            workDays.push(day);
          }
        });
      });
      availableDays.map((availableDay) => {
        const existDay = workDays.find((workDay) => workDay === availableDay);
        if (existDay === undefined) {
          unWorkDays.push(availableDay);
        }
      });
      setTimeout(() => {
        if (unWorkDays.join(',') === availableDays.join(',')) {
          unWorkDays = [];
        }
        this._hiddenDays = unWorkDays || [];
        // AGREGANDO EL CDN DINAMICAMENTE
        const script = document.createElement('script');
        const link = document.createElement('link');
        const fragment = document.createDocumentFragment();
        link.href = 'https://cdn.jsdelivr.net/npm/fullcalendar@5.11.3/main.css';
        link.rel = 'stylesheet';
        script.src =
          'https://cdn.jsdelivr.net/npm/fullcalendar@5.3.0/main.min.js';
        script.onload = () => {
          this.setCalendar();
          this.calendar?.gotoDate(meetingData.actualDate);
          this._calendarMonth = this.getCalendarDate().getMonth();
        };
        fragment.appendChild(link);
        fragment.appendChild(script);
        document.body.appendChild(fragment);
      }, 1000);
    }
  }
  @Input() set meet(value: any[]) {
    if (value) {
      this._events = [];
      value.map((item) => {
        verifyZDate(item);

        item.startTime = item.startHour;
        item.endTime = item.endHour;
        const { initToMs, endTimeToMs } = this.calendarSv.timeToMs(item);
        const date = new Date(item.date);
        const fixMont = date.getMonth() + 1;
        const fixDate = date.getDate();
        const shortDate = `${date.getFullYear()}-${
          fixMont < 10 ? '0' + fixMont : fixMont
        }-${fixDate < 10 ? '0' + fixDate : fixDate}`;
        const timeToHour = (endTimeToMs - initToMs) / 3600000;
        const existDateOnEvent = this._eventTime.findIndex(
          (event) => event.date === shortDate
        );
        const actualDay = date.getDay();
        if (existDateOnEvent !== -1) {
          const schedule = this.daysOfWeek.find(
            (schedule) => schedule.day === actualDay
          );
          this._eventTime[existDateOnEvent].busySchedule += timeToHour;
          const availableTimeAndDuration =
            this._eventTime[existDateOnEvent].busySchedule +
            this._duration / 60;
          if (availableTimeAndDuration > schedule?.hours) {
            this._eventTime[existDateOnEvent].available = false;
          }
        } else {
          this._eventTime.push({
            date: `${shortDate}`,
            busySchedule: timeToHour,
            available: true,
          });
        }
        let splitedDate = undefined;
        if (`${date}` !== 'Invalid Date') {
          splitedDate = date.toISOString().split('T');
        }
        const obj = {
          daysOfWeek: [date.getDay()],
          date: date,
          startTime: item.startHour,
          endTime: item.endHour,
          title: item.title || '',
        };
        this._reserved.push(obj);
        if (splitedDate) {
          this._events.push({
            id: item.id,
            title: item.title
              ? item.title
              : item.status === 'En espera'
              ? this.trSv.instant('EN_ESPERA_DE_CONFIRMACION')
              : this.trSv.instant('RESERVADO'), // a property!
            start: `${splitedDate[0]}T${item.startHour}`,
            end: `${splitedDate[0]}T${item.endHour}`,
            color: '#a0a0a0',
            className: item.class || 'reservedEvent',
          });
        }
      });
    }
  }

  @ViewChild('calendarEl', { static: true })
  calendarEl: ElementRef<HTMLDivElement>;
  public meetingData = [];
  public lastOperatorName = '';
  public calendar = undefined;
  public loading = true;
  public daysOfWeek: any[] = [];
  private _events = [];
  private _eventTime = [];
  private _hiddenDays: any[] = [];
  private _businessHours: any[] = [];
  private _reserved: any[] = [];
  private _duration: number = undefined;
  private _body = undefined;
  private _heightContent = undefined;
  private _calendarMonth = undefined;
  private _changedToDate = undefined;

  constructor(
    private uiSv: UiServices,
    private calendarSv: CalendarService,
    private trSv: TranslateService,
    private langSv: LangService,
    private paramSv: ParamServicesService
  ) {}

  ngOnInit() {}

  blockTurns(item) {
    // this._businessHours = [];
    let days: any[] = item.day.split(',');
    item.startTime = item.init;
    item.endTime = item.end;
    const currentDate = new Date();
    const currentHour =
      currentDate.getHours() > 10
        ? currentDate.getHours()
        : '0' + currentDate.getHours();
    const currentMinutes =
      currentDate.getMinutes() > 10
        ? currentDate.getMinutes()
        : '0' + currentDate.getMinutes();

    const startTimeToMs = timeToMilliseconds(item.init);
    const actualTimeToMs = timeToMilliseconds(
      `${currentHour}:${currentMinutes}`
    );

    const currentDay = new Date().getDay().toString();
    if (days.includes(currentDay)) {
      days = days.filter((day) => day !== currentDay);
      const obj = {
        daysOfWeek: [currentDay],
        startTime:
          actualTimeToMs > startTimeToMs
            ? `${currentHour}:${currentMinutes}`
            : item.init,
        endTime: item.end,
      };
      this._businessHours.push(obj);
    }

    const obj = {
      daysOfWeek: days,
      startTime: item.init,
      endTime: item.end,
    };
    this._businessHours.push(obj);
  }

  setCalendar() {
    this.calendar = new FullCalendar.Calendar(this.calendarEl.nativeElement, {
      initialView: 'dayGridMonth',
      allDaySlot: false,
      locale: this.langSv.langage,
      views: {
        dayGridMonth: {
          dayHeaderFormat: {
            weekday: 'long',
          },
        },
      },
      customButtons: {
        prevDate: {
          icon: 'chevron-left',
          click: (ev) => {
            this.controlChange('prev');
          },
        },
        nxtDate: {
          icon: 'chevron-right',
          click: (ev) => {
            this.controlChange('next');
          },
        },
      },
      headerToolbar: {
        start: 'prevDate', // will normally be on the left. if RTL, will be on the right
        center: 'title',
        right: 'nxtDate',
      },
      hiddenDays: this._hiddenDays,
      slotLabelFormat: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      },
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      },
      slotDuration: '00:30:00',
      slotLabelInterval: 30,
      eventClick: async (ev) => {
        if (ev.event.id === 'Cita') {
          // const tr = this.trSv.instant('DESEA_REMOVER_LA_CITA');
          // const { role } = await this.uiSv.presentAlert(tr);
          // if (role === 'accept') {
          //   this.removeDate();
          // }
        }
      },
      dateClick: async (ev) => {
        if (this.calendar.currentData.currentViewType === 'dayGridMonth') {
          if (this.paramSv.meeting) {
            await this.showGMTMessage();
          }
          this.clickedDate(ev, 'timeGrid');
          this._calendarMonth = this.getCalendarDate().getMonth();
        } else {
          if (this.blockDays) {
            this.selectDay(ev);
          }
        }
      },
      businessHours: this._businessHours,
      eventSources: {
        events: this._events,
      },
    });
    this.calendarSetting();
    this._calendarMonth = this.getCalendarDate().getMonth();
    return true;
  }

  async showGMTMessage() {
    await this.uiSv.showModal(GmtMessageComponent, {}, 'gmtModal');
  }

  async controlChange(direction) {
    direction === 'next' ? this.calendar.next() : this.calendar.prev();
    await this.calendarSetting();
    const changedMonth = this.getCalendarDate().getMonth();
    if (this._calendarMonth !== changedMonth) {
      this._calendarMonth = changedMonth;
      this._changedToDate = this.getCalendarDate();
      this.calendarSv.emitNewDate.emit(this._changedToDate);
    } else {
      const goDate = new Date(this.calendar.getDate());
      const actualDate = new Date();
      actualDate.setMilliseconds(0);
      actualDate.setHours(0, 0, 0);

      if (goDate < actualDate) {
        this.clickedDate(null, 'dayGridMonth');
        const msg = this.trSv.instant(
          'POR_FAVOR_SELECCIONE_UNA_FECHA_ACTUAL_O_MAYOR'
        );
        await this.uiSv.presentAlert(msg);
      }

      const pReservedEl: HTMLElement = document.querySelector(
        '[data-allreserved="true"]'
      );
      if (pReservedEl) {
        this.clickedDate(null, 'dayGridMonth');
        const msg = this.trSv.instant(
          'El dia se encuentra totalmente reservado'
        );
        await this.uiSv.presentAlert(msg);
      }
    }
  }

  getCalendarDate(): Date {
    const calendarDateFormat = this.calendar.getDate();
    const calendarDate = new Date(calendarDateFormat);
    return calendarDate;
  }

  canDate(hour, minute, actualDay, el?) {
    const calendarDateFormat = this.calendar.getDate();
    const calendarDate = new Date(calendarDateFormat);
    const actualDate = new Date();

    if (
      calendarDate.getDate() < actualDate.getDate() &&
      calendarDate.getMonth() < actualDate.getMonth()
    ) {
      return false;
    }

    const hoursToMs12 = Number(hour) * 3600000;
    const minutesToMs12 = Number(minute) * 60000;
    const duration = this._duration * 60000;
    const dateToMs = hoursToMs12 + minutesToMs12; //hora que desea ser agendada
    let isOutOfService = false;
    let canDate = false;
    let reserved = false;
    let difference = 0;
    const viewDays = this._businessHours.filter((schedule) =>
      schedule.daysOfWeek.find((day) => Number(day) === actualDay)
    );
    for (const schedule of viewDays) {
      const { initToMs, endTimeToMs } = this.calendarSv.timeToMs(schedule);
      if (dateToMs >= initToMs && dateToMs + duration <= endTimeToMs) {
        canDate = true;
        break;
      }
    }

    for (const schedule of this._reserved) {
      const { initToMs, endTimeToMs } = this.calendarSv.timeToMs(schedule);
      const scheduleDate = new Date(schedule.date);
      if (scheduleDate.toISOString() === calendarDate.toISOString()) {
        if (
          (dateToMs >= initToMs && dateToMs < endTimeToMs) || //verifica si la agenda comienza desde otra reserva
          (dateToMs + duration > initToMs &&
            dateToMs + duration < endTimeToMs) || //Verifica si la agenda obstruye un horario ya agendado por otra persona
          (dateToMs < initToMs && dateToMs + duration > endTimeToMs)
        ) {
          difference = (endTimeToMs - (dateToMs + duration)) / 60000;
          reserved = true;
          canDate = false;
          if (schedule.title) isOutOfService = true;
          break;
        }
      }
    }

    if (reserved) {
      if (el) {
        const sign = Math.sign(difference);
        let durationToHeight = 0;
        let directionBool = true;
        let direction = '';
        let style = `height: ${this._heightContent}px;`;
        let totalHg = 0;
        if (sign === 1) {
          directionBool = false;
          durationToHeight = ((this._duration - difference) / 60) * 24 * 2;
        } else {
          directionBool = true;
          durationToHeight = ((this._duration + difference) / 60) * 24 * 2;
        }
        totalHg = this._heightContent - durationToHeight;
        if (durationToHeight >= totalHg) {
          if (this._heightContent / 4 === totalHg) {
            direction = directionBool ? 'bottom' : 'top';
          } else {
            if (directionBool) {
              direction = 'top';
            } else {
              direction = 'bottom';
            }
          }
        } else {
          if (this._heightContent / 4 === totalHg) {
            direction = 'top';
          } else {
            if (!directionBool) {
              direction = 'bottom';
            } else {
              direction = 'top';
            }
          }
        }
        style += `background: linear-gradient(to ${direction}, ${
          durationToHeight > totalHg ? '#f00' : '#0f0'
        } ${durationToHeight > totalHg ? durationToHeight : totalHg}px, ${
          durationToHeight > totalHg ? '#0f0' : '#f00'
        } ${durationToHeight > totalHg ? totalHg : durationToHeight}px);`;
        el.setAttribute('style', style);
      } else {
        const msgMeet = isOutOfService
          ? 'se encuentra fuera de servicio'
          : 'ya se encuentra cubierto por otra cita';
        const tr = this.trSv.instant('EL_HORARIO_SELECCIONADO');
        const trSc = this.trSv.instant('POR_FAVOR_SELECCIONA_OTRO_HORARIO');
        this.uiSv.presentAlert(`${tr} ${msgMeet}. ${trSc}`);
      }
    }
    return canDate;
  }

  removeDate() {
    const event = this.calendar.getEventById('Cita');
    if (event) {
      event.remove();
    }
  }

  async selectDay(ev) {
    if (ev.jsEvent.target.className === 'fc-non-business') {
      const tr = this.trSv.instant(
        'LO_SENTIMOS_EL_SERVICIO_NO_ESTA_DISPONIBLE_EN_EL_HORARIO_SELECCIONADO'
      );
      return this.uiSv.presentAlert(tr, false);
    }
    const startHour = new Date(ev.dateStr);
    const canDate = this.canDate(
      startHour.getHours(),
      startHour.getMinutes(),
      startHour.getDay()
    );
    if (!canDate) {
      return;
    }
    startHour.setMinutes(startHour.getMinutes() + this._duration);
    const beginHour = startHour.getHours();
    const initMin = startHour.getMinutes();
    const fixedBeginHour = this.fixHours(beginHour);
    const fixedBeginMinutes = this.fixHours(initMin);
    const splitedTime = ev.dateStr.split('T');
    const body = {
      id: 'Cita',
      title: 'Cita',
      start: `${splitedTime[0]}T${splitedTime[1].slice(0, 5)}`,
      end: `${splitedTime[0]}T${fixedBeginHour}:${fixedBeginMinutes}`,
      className: 'dateEvent',
    };
    this.removeDate();
    const date = this.fixHours(startHour.getDate());
    const month = this.fixHours(startHour.getMonth() + 1);

    this._body = {
      startHour: splitedTime[1].slice(0, 5),
      endHour: `${fixedBeginHour}:${fixedBeginMinutes}`,
      duration: this._duration,
      serviceId: this.operator.serviceId,
      operatorId: this.operator.id,
      date: `${date}/${month}/${startHour.getFullYear()}`,
    };

    this.calendar.addEvent(body);
    const { data } = await this.uiSv.showModal(
      ShowTermsComponent,
      {},
      'modalAdmin'
    );
    if (data === 'accept') {
      await this.uiSv.showPopover(
        AcceptScheduleComponent,
        {
          init: splitedTime[1].slice(0, 5),
          end: `${fixedBeginHour}:${fixedBeginMinutes}`,
          calendarDate: this.calendar.getDate(),
        },
        'accept-schedule'
      );
      await this.sendMeet();
    } else {
      this.removeDate();
    }
  }

  fixHours(time) {
    const fixTime = time < 10 ? `0${time}` : time;
    return fixTime;
  }

  async clickedDate(ev, view) {
    if (this.isOperatorView) {
      const dateStr = ev.dateStr.split('-');
      const normalizedDate = `${dateStr[1]}-${dateStr[2]}-${dateStr[0]}`;
      this.openAgendedList.emit(normalizedDate);
      return;
    }
    const savedDate = this.calendar.getDate();

    this.setCalendar();
    this.calendar.gotoDate(savedDate);
    if (ev) {
      let goDate = new Date(ev.dateStr);
      goDate.setDate(goDate.getDate() + 1);
      goDate.setHours(23, 59, 0);
      const actualDate = new Date();
      const el: HTMLElement = ev.dayEl;
      if (goDate < actualDate && this.blockDays) {
        const msg = this.trSv.instant(
          'POR_FAVOR_SELECCIONE_UNA_FECHA_ACTUAL_O_MAYOR'
        );
        await this.uiSv.presentAlert(msg);
        return false;
      } else if (el.dataset.available) {
        const msg = this.trSv.instant('EL_DIA_ESTA_TOTALMENTE_AGENDADO');
        await this.uiSv.presentAlert(msg);
        return false;
      }

      const schedule = this._eventTime.find(
        (schedule) => schedule.date === ev.dateStr
      );
      if (!schedule || schedule.available) {
        this.calendar.changeView(view);
        this.calendar.gotoDate(ev.dateStr);
      } else {
        const tr = this.trSv.instant(
          'LO_SENTIMOS_ESTE_DIA_NO_TIENE_UN_HORARIO_DISPONIBLE_POR_FAVOR_SELECCIONA_OTRO_DIA'
        );
        this.uiSv.presentAlert(tr);
      }
    } else if (view) {
      this.calendar.changeView(view);
    }
  }

  async calendarSetting() {
    this.calendar.updateSize();
    this.calendar.render();
    setTimeout(() => {
      const td = document.querySelectorAll('.fc-timegrid-slot');
      const monthDays = document.querySelectorAll('.fc-daygrid-day');
      const actualCalendarDay = document.querySelector('.fc-day-today');
      if (actualCalendarDay) {
        const todayTxt = document.createElement('p');
        const todayTranslated = this.trSv.instant('HOY');
        todayTxt.classList.add('today-text');
        todayTxt.innerText = todayTranslated;
        const now = new Date();
        const existScheduleToToday = this._events.find((x) => {
          const startDate = new Date(x.start);
          return this.formatDates(now) === this.formatDates(startDate);
        });
        if (!existScheduleToToday) {
          todayTxt.classList.add('center');
        }
        actualCalendarDay.appendChild(todayTxt);
      }
      const actualDate = new Date();
      this.disableUnAvailableDates();

      if (this.blockDays) {
        monthDays.forEach((item: any) => {
          const date = new Date(item.dataset.date);
          date.setDate(date.getDate() + 1);
          if (date < actualDate) {
            item.classList.add('disableDayOfCalendar');
          }
        });

        td.forEach((item) => {
          item.addEventListener('mouseenter', (ev: any) => {
            if (
              ev.target.tagName === 'TD' &&
              ev.target.classList.contains('fc-timegrid-slot-lane')
            ) {
              this.setContent(ev.target);
            }
          });
          item.addEventListener('mouseleave', (ev) => {
            this.removeDiv(ev.target);
          });
        });
      }
    });
    this.loading = false;
    this.calendarSv.checkIfADayIsAvailable(
      this._events,
      this._businessHours,
      this._duration
    );
    if (this._changedToDate) {
      await this.calendar.gotoDate(this._changedToDate);
      this._changedToDate = undefined;
    }
    return true;
  }

  formatDates(date: Date) {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear}`;
  }

  disableUnAvailableDates() {
    this._eventTime.map((item) => {
      const el = document.querySelector(`[data-date="${item.date}"]`);
      if (el && !item.available) {
        el.classList.add('unAvailableDate');
      }
    });
  }

  removeDiv(el) {
    const divisor = document.getElementById('divisor');
    if (divisor) el.removeChild(divisor);
  }

  setContent(el) {
    const splitedHour = el.dataset.time.split(':');
    const hour = splitedHour[0];
    const min = splitedHour[1];
    const actualDay = new Date(this.calendar.getDate()).getDate();
    el.setAttribute('style', 'position: relative');
    const contentEl = document.createElement('DIV');
    const style = `height: ${this._heightContent}px`;
    contentEl.setAttribute('style', style);
    contentEl.setAttribute('id', 'divisor');
    contentEl.setAttribute('class', 'divisorTime');
    el.appendChild(contentEl);
    this.canDate(hour, min, actualDay, contentEl);
  }

  async sendMeet() {
    if (!this._body) {
      const tr = this.trSv.instant('DEBES_AGENDAR_ANTES_DE_CONTINUAR');
      return await this.uiSv.presentAlert(tr);
    }

    this.emitMeet.emit(this._body);
  }
}
